export const fr = {
  name: "French",
  flagCode: "fr",
  locale: "fr-FR",
  project: {
    name: "Driver Signup",
  },
  key: "fr",
  validations: {
    PLEASE_SELECT_CITY: "Veuillez sélectionner une ville.",
    PLEASE_SELECT_SERVICE: "Veuillez sélectionner un service.",
    PLEASE_SELECT_DRIVER_TYPE: "Veuillez sélectionner un type de chauffeur.",
    PLEASE_INPUT_FIRSTNAME: "Veuillez entrer votre prénom.",
    PLEASE_INPUT_LASTNAME: "Veuillez entrer votre nom de famille.",
    PLEASE_INPUT_EMAIL: "Veuillez entrer votre adresse e-mail.",
    INVALID_EMAIL: "Veuillez utiliser un email valide.",
    PLEASE_INPUT_MOBILE_PHONE: "Veuillez entrer votre numéro de téléphone",
    INVALID_PHONE_NUMBER: "Veuillez entrer un numéro de téléphone valide",
    PHONE_NUNBER_EXITS: "Le numéro de téléphone est déjà utilisé avec un autre compte.",
    USERNAME_EXITS: "Ce nom d'utilisateur existe déjà dans notre système.",
    ERROR_INPUT_VALID_USERNAME:
      "Le nom d'utilisateur ne peut contenir que des lettres minuscules et des chiffres, et doit comporter entre 3 et 20 caractères.",
    FIELD_IS_REQUIRED: "This field is required.",
    REFERRAL_CODE_INVALID: "Le code de parrainage est invalide.",
    EMAIL_EXITS: "Cet e-mail existe déjà. Veuillez en saisir un autre.",
    INVALID_USERNAME: "Veuillez spécifier un nom d'utilisateur valide.",
    FIELD_IS_REQUIRED_BETWEEN_3_TO_20:
      "Le nom d'utilisateur doit comporter entre 3 et 20 caractères.",
    PHONE_NUNBER_EXITS_IN_GROUP: "",
  },
  errors: {
    3034: "Ce téléphone existe sur le système. Veuillez entrer un autre.",
    4001: "La plaque d'immatriculation existe.",
    NETWORK_ERROR: "Erreur: Nrreur Réseau",
  },
  general: {
    CONTINUE: "Continuer",
    STEP_COMPLETE: "{0}/{1} Compléter",
    STEP_HEADER: "Étape {0}",
    BACK: "Retour",
    NEXT: "Suivant",
    SUBMIT: "Soumettre",
    Clear_Selected_Items: "Effacer les éléments sélectionnés",
    no_results: "Aucun résultat",
    add_new_item: "Ajouter un nouveau",
  },
  home: {
    BECOME: "Devenez chauffeur %{name}.",
    HEADING: "Entrez vos informations de base pour commencer",
    APPLY_NOW: "S'inscrire",
    INDIVIDUAL_CAR_GOJO: "Transport/Taxi - Je possède un véhicule",
    INDIVIDUAL_CAR: "Transport - Je possède un véhicule",
    COMPANY_CAR: "Transport - Véhicule de l'entreprise",
    DELIVERY_INDIVIDUAL_CAR: "Livraison - Je possède un véhicule",
    DELIVERY_COMPANY_CAR: "Livraison - Véhicule de l'entreprise",
    PLACEHOVER_SELECT_PRE_CITY: "City",
    PLACEHOVER_SELECT_REGISTRATION_TYPE: "Sélectionnez le type de pilote",
    USERNAME: "Nom d'utilisateur",
    FIRST_NAME: "Prénom",
    LAST_NAME: "Nom de famille",
    EMAIL: "Adresse mail (optional)",
    PHONE_NUMBER: "Numéro de téléphone",
    REFERRAL_CODE: "Code de parrainage (optionnel)",
    I_AGREE_TO: "En m'inscrivant, j'ai lu et accepté la",
    TERMS_OF_USE: "Conditions d'utilisation",
    AND: "et",
    PRIVACY_POLICY: "Politique de confidentialité",
    I_AGREE_TO_AFTER: ".",
    Company: "Fournisseur",
  },
  finish: {
    FINISH_1: "Merci de vous être inscrit à %{name}!",
    FINISH_3: "Connectez-vous maintenant pour commencer !",
    FINISH_USE_PASSWORD_1: "Presque terminé !",
    FINISH_USE_PASSWORD_2:
      "Pour activer votre compte et recevoir des courses, veuillez suivre ces étapes :",
    FINISH_USE_PASSWORD_3:
      "1. Connectez-vous avec votre numéro de téléphone enregistré",
    FINISH_USE_PASSWORD_4:
      "2. Mot de passe : <span style='font-weight: bold'>12345678</span>",
    FINISH_USE_PASSWORD_5: "3. Complétez votre demande",
    OK: "Connexion",
    downloadApp:
      "Téléchargez l'application chauffeur <span style='color: %{color}' >%{name}</span> maintenant et connectez-vous avec votre numéro de téléphone enregistré.",
  },
  datePlaceHolder: "MM/DD/YYYY",
};
